import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getActiveLinksItems } from 'selectors';
import { useSelectorProps } from 'hooks';
import { fetchLinksData } from 'actions';

import ContentSection from 'components/ContentSection';

import { Title, LinksList, LinkItem } from './styles';

const LinksBlock = () => {
  const dispatch = useDispatch();
  const selectorProps = useSelectorProps();

  const activeLinksItems = useSelector(state =>
    getActiveLinksItems(state, selectorProps)
  );

  useEffect(() => {
    dispatch(fetchLinksData(selectorProps));
  }, [selectorProps]);

  return activeLinksItems.map(({ name, id, active, links }) =>
    active ? (
      <ContentSection key={id}>
        <Title>{name}</Title>

        <LinksList>
          {links.map(
            ({ url: linkUrl, name: linkName, id: linkId, rel: linkRel }) => (
              <LinkItem
                key={linkId}
                href={linkUrl}
                title={linkName}
                rel={linkRel || null}
              >
                {linkName}
              </LinkItem>
            )
          )}
        </LinksList>
      </ContentSection>
    ) : null
  );
};

export default LinksBlock;
